import { render, staticRenderFns } from "./GroupTypeVariantList.vue?vue&type=template&id=185589c8&scoped=true"
import script from "./GroupTypeVariantList.vue?vue&type=script&lang=js"
export * from "./GroupTypeVariantList.vue?vue&type=script&lang=js"
import style0 from "./GroupTypeVariantList.vue?vue&type=style&index=0&id=185589c8&prod&lang=scss"
import style1 from "./GroupTypeVariantList.vue?vue&type=style&index=1&id=185589c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185589c8",
  null
  
)

export default component.exports